import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Pipe({name: 'imagePipe'})
export class ImagePipe implements PipeTransform {
    constructor(private domSanitizer: DomSanitizer) {}

    transform(value: any, command: any, width: any): any {
        if (command) {
            if (command == 'resize') {
                if (width) {
                    value = encodeURIComponent(value);
                    return environment.apiUrl + '/api/image/resize/' + width + '?image=' + value; 
                }
            }
        }
        return value;
    }
}
